import { useEffect, useState } from "react";
import { Container, Spinner, Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { usePage } from "../../hooks/usePage";
import { usePrecargaEvents } from "../../hooks/usePrecargaEvents";
import { legacyAdminGet } from "../../utils/PrecargaApi";

export default function PrecargasOrderDetail() {
  usePage({ title: "Precargas - Detalle de Orden" });

  const { eventid, orderId } = useParams();
  const navigate = useNavigate();
  const cashlessEventId = eventid ? parseInt(eventid) : null;

  const { precargaEvent, isLoadingPrecargaEvent } = usePrecargaEvents({
    cashlessEventId,
  });

  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (precargaEvent?.id && orderId) {
      setIsLoading(true);
      legacyAdminGet(`${precargaEvent.id}/orders/${orderId}/detail`)
        .then((data) => {
          if (data?.order) {
            setOrder({
              ...data.order,
              user: data.order.user ?? data.user,
              wallet: data.wallet,
              transactions: data.transactions ?? [],
            });
          } else {
            setOrder(data);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching order detail:", error);
          setIsLoading(false);
        });
    }
  }, [precargaEvent?.id, orderId]);

  if (isLoadingPrecargaEvent || isLoading) {
    return (
      <Container fluid>
        <div className="text-center p-5">
          <Spinner animation="border" />
          <p className="mt-3">Cargando detalle de orden...</p>
        </div>
      </Container>
    );
  }

  if (!order) {
    return (
      <Container fluid>
        <div className="text-center p-5">
          <p>No se encontró la orden</p>
          <Button onClick={() => navigate(`/${eventid}/preloads/orders`)}>
            Volver a Órdenes
          </Button>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col>
          <Button
            variant="secondary"
            onClick={() => navigate(`/${eventid}/preloads/orders`)}
          >
            ← Volver a Órdenes
          </Button>
        </Col>
      </Row>

      <h2>Detalle de Orden</h2>

      <Row>
        <Col md={6}>
          <Card className="mb-3">
            <Card.Header>
              <strong>Información de la Orden</strong>
            </Card.Header>
            <Card.Body>
              <p>
                <strong>ID:</strong> {order.id}
              </p>
              <p>
                <strong>Order ID:</strong> {order.orderId}
              </p>
              <p>
                <strong>Estado:</strong> {order.status}
              </p>
              <p>
                <strong>Monto:</strong> ${order.amount / 100}
              </p>
              <p>
                <strong>Comisiones:</strong> ${order.fees / 100}
              </p>
              <p>
                <strong>Total:</strong> ${order.total / 100}
              </p>
              <p>
                <strong>Moneda:</strong> {order.currency}
              </p>
              <p>
                <strong>Proveedor:</strong> {order.provider}
              </p>
              {order.providerTransactionId && (
                <p>
                  <strong>ID Transacción Proveedor:</strong>{" "}
                  {order.providerTransactionId}
                </p>
              )}
              {order.providerStatusCode && (
                <p>
                  <strong>Estado Proveedor:</strong> {order.providerStatusCode}
                </p>
              )}
              <p>
                <strong>Modo Test:</strong> {order.testMode ? "Sí" : "No"}
              </p>
              <p>
                <strong>Fecha de Creación:</strong>{" "}
                {new Date(order.createdAt).toLocaleString()}
              </p>
              <p>
                <strong>Última Actualización:</strong>{" "}
                {new Date(order.updatedAt).toLocaleString()}
              </p>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="mb-3">
            <Card.Header>
              <strong>Información del Usuario</strong>
            </Card.Header>
            <Card.Body>
              <p>
                <strong>ID:</strong> {order.user?.id}
              </p>
              <p>
                <strong>Email:</strong> {order.user?.email}
              </p>
              <p>
                <strong>Teléfono:</strong> {order.user?.phone || "N/A"}
              </p>
              <p>
                <strong>Email Verificado:</strong>{" "}
                {order.user?.emailVerified ? "Sí" : "No"}
              </p>
              <p>
                <strong>Teléfono Verificado:</strong>{" "}
                {order.user?.phoneVerified ? "Sí" : "No"}
              </p>
            </Card.Body>
          </Card>

          <Card className="mb-3">
            <Card.Header>
              <strong>Billetera</strong>
            </Card.Header>
            <Card.Body>
              <p>
                <strong>Wallet ID:</strong> {order.walletId}
              </p>
              <Button
                variant="link"
                onClick={() =>
                  navigate(`/${eventid}/preloads/wallets/${order.walletId}`)
                }
              >
                Ver Billetera
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
